import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import DataCacheService from '@/shared/services/DataCacheService';
import EditableSelect from './EditableSelect';
const messages = defineMessages({
    SelectAValue: { id: 'SelectAValue', defaultMessage: 'Select a value' },
});
const EditableCompanySelect = ({ value = null, onChange, required = false, readOnly = false, placeholder, allCompanies = false, }) => {
    const intl = useIntl();
    const [options, setOptions] = useState([]);
    useEffect(() => {
        const companies = (allCompanies
            ? DataCacheService.getAllCompanies()
            : DataCacheService.getCompanies())
            .map(x => ({ id: x.id, label: x.name }))
            .sort(dynamicSort('label'));
        setOptions(companies);
    }, []);
    if (typeof placeholder === 'undefined')
        placeholder = intl.formatMessage(messages.SelectAValue);
    return (_jsx(EditableSelect, { value: value, options: options, onChange: onChange, required: required, readOnly: readOnly, placeholder: placeholder }));
};
export default EditableCompanySelect;
